import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalization } from '../../contexts/LocalizationContext';
import fragranceNoteService from '../../services/fragranceNoteService';
import Input from '../../components/Common/Input';
import Button from '../../components/Common/Button';

const CreateFragranceNote = () => {
  const { get, isRtl } = useLocalization();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nameEn: '',
    nameAr: '',
    type: 'top',
    descriptionEn: '',
    descriptionAr: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await fragranceNoteService.create(formData);
      navigate('/fragrance-notes');
    } catch (error) {
      console.error('Error creating fragrance note:', error);
      alert(isRtl ? 'حدث خطأ أثناء إنشاء الملاحظة' : 'Error creating fragrance note');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="page-header">
        <div className="page-header-content">
          <div className="page-header-main">
            <Button variant="secondary" onClick={() => navigate('/fragrance-notes')}>
              {isRtl ? '← العودة' : '← Back'}
            </Button>
            <h1 className="page-title">{get('add_new_note')}</h1>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <Input
              label={isRtl ? 'الاسم (إنجليزي)' : 'Name (English)'}
              value={formData.nameEn}
              onChange={(e) => setFormData({ ...formData, nameEn: e.target.value })}
              required
            />
            <Input
              label={isRtl ? 'الاسم (عربي)' : 'Name (Arabic)'}
              value={formData.nameAr}
              onChange={(e) => setFormData({ ...formData, nameAr: e.target.value })}
              required
            />
            <div className="form-group">
              <label className="form-label">{isRtl ? 'النوع' : 'Type'}</label>
              <select
                className="form-select"
                value={formData.type}
                onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                required
              >
                <option value="top">{isRtl ? 'علوي' : 'Top'}</option>
                <option value="middle">{isRtl ? 'وسطي' : 'Middle'}</option>
                <option value="base">{isRtl ? 'قاعدي' : 'Base'}</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">{isRtl ? 'الوصف (إنجليزي)' : 'Description (English)'}</label>
              <textarea
                className="form-textarea"
                value={formData.descriptionEn}
                onChange={(e) => setFormData({ ...formData, descriptionEn: e.target.value })}
                rows="4"
              />
            </div>
            <div className="form-group">
              <label className="form-label">{isRtl ? 'الوصف (عربي)' : 'Description (Arabic)'}</label>
              <textarea
                className="form-textarea"
                value={formData.descriptionAr}
                onChange={(e) => setFormData({ ...formData, descriptionAr: e.target.value })}
                rows="4"
              />
            </div>
            <div style={{ display: 'flex', gap: 'var(--sp-3)', justifyContent: 'flex-end' }}>
              <Button variant="secondary" onClick={() => navigate('/fragrance-notes')}>
                {get('cancel')}
              </Button>
              <Button variant="primary" type="submit" disabled={isLoading}>
                {get('save')}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateFragranceNote;
